var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.121734 1.65309C-0.040578 1.49078 -0.040578 1.22762 0.121734 1.06531L0.879607 0.307435C1.04192 0.145123 1.30508 0.145123 1.46739 0.307435L12.3414 11.1814C12.5037 11.3438 12.5037 11.6069 12.3414 11.7692L11.5835 12.5271C11.4212 12.6894 11.1581 12.6894 10.9957 12.5271L0.121734 1.65309Z",
    fill: "url(#paint0_linear_420_116)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9968 0.121734C11.1591 -0.0405781 11.4223 -0.040578 11.5846 0.121734L12.3425 0.879607C12.5048 1.04192 12.5048 1.30508 12.3425 1.46739L1.46848 12.3414C1.30617 12.5037 1.04301 12.5037 0.880699 12.3414L0.122826 11.5835C-0.039486 11.4212 -0.039486 11.1581 0.122826 10.9957L10.9968 0.121734Z",
    fill: "url(#paint1_linear_420_116)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_420_116",
    x1: 0,
    y1: 6.32442,
    x2: 12.4642,
    y2: 6.32442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_420_116",
    x1: 0,
    y1: 6.32442,
    x2: 12.4642,
    y2: 6.32442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960E0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorClose);
export default __webpack_public_path__ + "static/media/error_close.d75f5e175d7550fc39dfb83cf65685f2.svg";
export { ForwardRef as ReactComponent };